import { put, call, takeLatest } from 'redux-saga/effects';

import { INVENTORY_REQUEST_INVENTORY_SETTINGS } from '../../actions/inventory/advancedInventorySettings/constants';
import * as actAdvancedInventorySettings from '../../actions/inventory/advancedInventorySettings';

import * as apiactAdvancedInventorySettings from '../../api/inventory/advancedInventorySettings';

export function* getAdvancedInventorySettings() {
  const advancedInventorySettings = yield call(
    apiactAdvancedInventorySettings.getAdvancedInventorySettings
  );

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { advanced_adjustment, advanced_purchase_order, advanced_transfer } =
    advancedInventorySettings.data;
  yield put(
    actAdvancedInventorySettings.setAdvancedInventorySettings({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      advanced_adjustment,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      advanced_purchase_order,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      advanced_transfer,
    })
  );
}

export default function* saga() {
  yield takeLatest(
    INVENTORY_REQUEST_INVENTORY_SETTINGS,
    getAdvancedInventorySettings
  );
}
